import SeoLandingPage from "@/components/SeoLandingPage";

const EstateCleanout = () => (
  <SeoLandingPage
    slug="estate-cleanout-wisconsin"
    metaTitle="Estate Cleanout Wisconsin | Compassionate, Discreet Service"
    metaDescription="Estate cleanout services across Wisconsin with careful sorting, donation handling, debris hauling, and a clear project estimate."
    h1="Estate Cleanout Services in Wisconsin"
    heroImage="/images/20240710_172824.jpg"
    heroIntro="Whether you're handling a loved one's estate, preparing a property for sale, or facing an overwhelming cleanup project, we'll make the process simple and respectful."
    serviceName="Estate Cleanout"
    bullets={[
      "Full home cleanout: every room, closet, attic, basement, garage, and outbuilding.",
      "Careful sorting of keepsakes, paperwork, and items family wants to keep.",
      "Donation pickup and itemized receipts for tax purposes.",
      "Estate sale coordination with vetted local partners.",
      "Hazardous-waste removal: paint, chemicals, propane, electronics.",
      "Broom-clean finish ready for listing, closing, or new tenants.",
    ]}
    whyUs={[
      "Serving Northeast Wisconsin property owners since 2018.",
      "Licensed, insured, and background-checked crews you can trust inside a loved one's home.",
      "We pause and check before anything is removed — photos, jewelry, and documents come first.",
      "Out-of-state executors welcome: we send photo updates and handle keys with the realtor.",
    ]}
    processSteps={[
      { title: "Free walkthrough or photo estimate", detail: "Visit the property with us, or upload photos online and get a written estimate within 15 minutes." },
      { title: "Family review", detail: "We hold the property untouched while you and other heirs identify keepsakes and valuables." },
      { title: "Sort, donate, haul", detail: "Our crew handles every item — donated, recycled, or responsibly disposed of." },
      { title: "Final walkthrough", detail: "Property is left broom-clean and ready for sale, rental, or transfer." },
    ]}
    faqs={[
      { q: "How long does an estate cleanout take in Wisconsin?", a: "Most single-family estate cleanouts in Wisconsin are completed in 1–3 days. Larger properties or homes with decades of belongings may take up to a week. We give you a firm timeline before we start." },
      { q: "Do you donate usable items?", a: "Yes. We partner with Goodwill, St. Vincent de Paul, and other local Wisconsin nonprofits. Donations are documented and a receipt is provided for the executor's tax records." },
      { q: "What if family members live out of state?", a: "We work with out-of-state executors all the time. We send before/during/after photos, handle keys with the realtor or attorney, and provide written progress updates." },
      { q: "How much does an estate cleanout cost in Wisconsin?", a: "Most estate cleanouts in Northeast Wisconsin range from $800 to $4,500 depending on the size of the home, the amount of contents, and access. A free estimate locks in your price before any work begins." },
    ]}
    ctaHeadline="Let us carry the load."
  />
);

export default EstateCleanout;
